module.exports = __webpack_public_path__ + "img/finland-leukaemia-male.432ec96e.png";